"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "formatTwoDecimals", {
  enumerable: true,
  get: function get() {
    return _format.formatTwoDecimals;
  }
});
exports.getMonetizable = void 0;
Object.defineProperty(exports, "getPercentageRange", {
  enumerable: true,
  get: function get() {
    return _format.getPercentageRange;
  }
});
var _constants = require("@nerdwallet/marketplace/constants");
var _common = require("@nerdwallet/marketplace/selectors/common");
var _format = require("@nerdwallet/marketplace/utils/format");
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/utils/format` directly.
 */

/**
 *
 * @param {Object} marketplaceEntity  the marketplace entity object
 *
 * @return {String}   the expected shopping finished event monetizable string
 * One of 'yes_assumed',
 *        'no',
 *        'no_because_of_limit',
 *        'no_because_of_lead',
 */
var getMonetizable = function getMonetizable(marketplaceEntity) {
  return (0, _common.isNonMonetizing)(marketplaceEntity) ? _constants.MONETIZATION_STATUSES.NO : _constants.MONETIZATION_STATUSES.YES_ASSUMED;
};
exports.getMonetizable = getMonetizable;